import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "label", "radio", "total_area" ]

  connect() {
    this.radioTargets.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        this.labelTargets.forEach((label) => {
          if (label !== event.target.nextElementSibling) {
            label.style.backgroundColor = 'white'
          }
        });
        event.target.nextElementSibling.style.backgroundColor = 'rgb(238, 241, 251)'
      });
    });
  }
}
